<template>
  <div>
    <ProgressBar
      v-if="!isLiteView()"
      :active-step="pageTitle"
    />
    <PageHeading
      :default-heading="pageTitle"
      :edit-heading="pageTitle"
    />
    <form
      novalidate="novalidate"
      @submit.prevent
    >
      <div class="pvd-container container-divider">
        <p>
          You previously indicated that your trust account can't be opened online for one or more of the following reasons:
        </p>
        <ul class="pvd-list-bullet">
          <li>
            The trust is considered a foreign trust, or was created in a state requiring a notary.
          </li>
          <li>
            The grantors or trustees do not have a valid US SSN.
          </li>
          <li>
            One or more of the trustees is an entity and not a person.
          </li>
        </ul>
        <p>
          Although you can’t continue online at this time, you can still open the account with us using the paper application.
          You can have the Fidelity Account<sup>&#xae;</sup> Trust Application notarized online.
        </p>
        <p>
          <a
            href="https://www.fidelity.com/customer-service/forms-applications/brokerage-trust-agree"
            target="_blank"
          >
            Download the Fidelity Account<sup>&#xae;</sup> Application Supporting Documents for Trusts
          </a>
        </p>
        <p>
          <a
            href="https://www.notarycam.com/fidelityinvestments/"
            target="_blank"
          >
            Notarize your Fidelity Account<sup>&#xae;</sup> Trust Application online with NotaryCam
          </a>
        </p>
      </div>
      <PageNavigation
        primary-button-type="button"
        show-primary-button="N"
        :secondary-button-label="pd_content.secondary_button.default"
        :page-exit-url="pd_content.overlay_exit_link.overview_url"
      />
    </form>
    <div
      id="fs-steps"
      class="personal-info-page"
      data-operation="IdentifyUser"
      data-step="Init"
      style="display: none"
    >
      &nbsp;
    </div>
  </div>
</template>

<script>
import ProgressBar from '../components/ProgressBar.vue';
import PageNavigation from '../components/PageNavigation.vue';
import PageHeading from '../components/PageHeading.vue';
import dataHelper from '../mixins/dataHelper';
import dataSanitize from '../mixins/dataSanitize';
import measurement from '../mixins/measurement';
import utilityFunctions from '../mixins/utility';
import validationHelper from '../mixins/validationHelper';
import widgetHelper from '../mixins/widgetHelper';
import pageNavigationHelper from '../mixins/pageNavigationHelper';

export default {
  name: 'TrustRole',
  components: {
    ProgressBar,
    PageNavigation,
    PageHeading,
  },
  mixins: [
    dataHelper,
    dataSanitize,
    measurement,
    utilityFunctions,
    validationHelper,
    widgetHelper,
    pageNavigationHelper,
  ],
  data() {
    return {
      backButtonAttempt: false,
      pageTitle: 'Download a trust account application',
    };
  },
  computed: {},
  mounted() {
    this.configureBackButtonFunctionality(() => this.$emit('invoke-previous'));
    this.removeModalClassIfExists();

    document.title = this.setTitle(this.pageTitle);
  },

  methods: {
    nextButtonClicked() {
      this.performNavigation(this.pd_content.primary_button.value);
    },
  },
};

</script>

<style scoped>
  .top-margin-zero {
    margin-top: 0;
  }
</style>
